// src/components/Topbar.js
import React, { useState, useRef, useEffect } from "react";

export default function Topbar({ customers = [], onLogout, setSidebarOpen }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const expiringSoon = customers.filter((c) => {
    if (!c.endDate) return false;
    const daysLeft =
      (new Date(c.endDate) - new Date()) / (1000 * 60 * 60 * 24);
    return daysLeft > 0 && daysLeft <= 7;
  });

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const now = new Date().getHours();
  const greeting =
    now < 12 ? "Good morning" : now < 18 ? "Good afternoon" : "Good evening";

  return (
    <div className="h-16 bg-white dark:bg-gradient-to-r dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 border-b border-green-200 dark:border-slate-700 flex items-center justify-between px-6 shadow-sm">

      {/* LEFT SIDE */}
      <div className="flex items-center gap-4">

        {/* MOBILE MENU BUTTON */}
        <button
          onClick={() => setSidebarOpen(prev => !prev)}
          className="text-2xl text-green-700 dark:text-white hover:text-green-800 transition-colors"
        >
          ☰
        </button>

        <h1 className="text-base font-semibold text-green-900 dark:text-white">
          {greeting}!
        </h1>

      </div>

      {/* RIGHT SIDE */}
      <div className="flex items-center gap-6" ref={dropdownRef}>

        {/* Notification Bell */}

      </div>
    </div>
  );
}